import { useDetectMobileKeyboardOpen } from "@certn/utils";
import { css } from "@emotion/css";
import { PropsWithChildren } from "react";

import { ButtonGroup } from "../button/ButtonGroup";

interface Props extends PropsWithChildren {
  leftContent?: React.ReactNode;
  testID?: string;
}

export function DialogFooter(props: Props) {
  const isMobileKeyboardOpen = useDetectMobileKeyboardOpen();
  return (
    <div
      className={
        isMobileKeyboardOpen ? styles.keyboardOpenOnMobile : styles.dialogFooter
      }
    >
      <div>{props.leftContent}</div>
      <ButtonGroup justify="end">{props.children}</ButtonGroup>
    </div>
  );
}

const styles = {
  dialogFooter: css({
    borderTopStyle: "solid",
    borderTopWidth: 1,
    flexShrink: 0,
    paddingBottom: "var(--space-4)",
    paddingLeft: "var(--space-5)",
    paddingRight: "var(--space-5)",
    paddingTop: `calc(${"var(--space-4)"} - 1px)`,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderColor: "var(--border-base)",
  }),
  keyboardOpenOnMobile: css({
    display: "none",
  }),
};
